import React from "react";

/**
 * 全局错误边界
 * 捕获子组件渲染期抛出的异常,给用户友好的「重试 / 返回首页」选项,
 * 而不是白屏。可选接 Sentry 等错误监控(在 Batch 2)。
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // 控制台留痕,Batch 2 接 Sentry 时这里挂钩
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
    this.setState({ info });
    if (typeof window !== "undefined" && window.__sentry__) {
      try { window.__sentry__.captureException(error); } catch {}
    }
  }

  handleReset = () => {
    this.setState({ error: null, info: null });
  };

  handleHardReload = () => {
    try {
      // 先清掉可能损坏的本地缓存(token 保留,免得用户重登)
      const keep = ["syj_token", "syj_user"];
      const all = Object.keys(localStorage);
      for (const k of all) {
        if (!keep.includes(k)) localStorage.removeItem(k);
      }
    } catch {}
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    const FF = "'Noto Sans SC','PingFang SC','Helvetica Neue','Microsoft YaHei',sans-serif";
    const errorText = String(this.state.error?.message || this.state.error || "未知错误");

    return (
      <div style={{
        minHeight: "100vh", maxWidth: 390, margin: "0 auto",
        background: "#fff", display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        padding: "32px 28px", fontFamily: FF, textAlign: "center",
      }}>
        <div style={{
          width: 78, height: 78, borderRadius: "50%",
          background: "linear-gradient(135deg,#ffe5e5,#ffd0d0)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 36, marginBottom: 20,
        }}>⚠️</div>
        <div style={{ fontSize: 18, color: "#1a1a1a", fontWeight: 600, marginBottom: 8 }}>
          页面出了点小问题
        </div>
        <div style={{ fontSize: 13, color: "#888", lineHeight: 1.6, marginBottom: 6 }}>
          请稍后重试,如反复出现请联系客服
        </div>
        <div style={{
          fontSize: 11, color: "#bbb",
          background: "#f7f6f4", padding: "8px 12px", borderRadius: 8,
          maxWidth: 320, marginBottom: 24, wordBreak: "break-word",
          fontFamily: "monospace",
        }}>
          {errorText.slice(0, 200)}
        </div>
        <div style={{ display: "flex", gap: 10, width: "100%", maxWidth: 280 }}>
          <button onClick={this.handleReset} style={{
            flex: 1, padding: "12px 0", background: "#fff",
            border: "1.5px solid #1a1a1a", borderRadius: 11,
            cursor: "pointer", fontSize: 13, fontFamily: FF,
            color: "#1a1a1a", fontWeight: 500,
          }}>重试</button>
          <button onClick={this.handleHardReload} style={{
            flex: 1, padding: "12px 0",
            background: "linear-gradient(135deg,#e03030,#c42020)",
            color: "#fff", border: "none", borderRadius: 11,
            cursor: "pointer", fontSize: 13, fontFamily: FF, fontWeight: 600,
            boxShadow: "0 4px 12px rgba(224,48,48,0.25)",
          }}>重新加载</button>
        </div>
      </div>
    );
  }
}
